const CallIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Icon/phone'>
      <g id='Vector'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.8087 8.67154C12.3167 7.68736 11.5834 6.95414 10.5993 6.46205C10.3934 6.35914 10.31 6.10886 10.4129 5.90304C10.5158 5.69721 10.7661 5.61379 10.9719 5.7167C12.1174 6.28942 12.9814 7.15341 13.5541 8.29886C13.657 8.50468 13.5736 8.75496 13.3678 8.85787C13.1619 8.96079 12.9117 8.87736 12.8087 8.67154Z'
          fill='black'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.764 8.43154C14.6258 6.15516 12.9234 4.45278 10.647 3.31458C10.4412 3.21167 10.3577 2.96139 10.4607 2.75557C10.5636 2.54974 10.8138 2.46631 11.0197 2.56923C13.4573 3.78806 15.2905 5.62121 16.5093 8.05887C16.6122 8.26469 16.5288 8.51497 16.323 8.61788C16.1171 8.7208 15.8669 8.63737 15.764 8.43154Z'
          fill='black'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.31487 3.69598C4.1328 3.51391 3.83084 3.53891 3.68118 3.74842L2.30962 5.66861C1.80485 6.37529 1.79521 7.30835 2.29945 7.99005C3.34656 9.40565 4.9096 11.3618 6.56555 13.0177C8.22151 14.6737 10.1776 16.2367 11.5932 17.2838C12.2749 17.7881 13.208 17.7784 13.9147 17.2737L15.8349 15.9021C16.0444 15.7524 16.0694 15.4505 15.8873 15.2684L13.4721 12.8532C13.3453 12.7264 13.1515 12.6949 12.9911 12.7751L12.0975 13.2219C11.4076 13.5669 10.549 13.6288 9.85206 13.1248C9.38033 12.7836 8.76832 12.2742 8.03869 11.5446C7.44059 10.9465 6.97527 10.3787 6.63406 9.91649C6.04804 9.12256 6.05385 8.10077 6.47051 7.26745L6.80815 6.59217C6.88835 6.43176 6.85691 6.23802 6.7301 6.11121L4.31487 3.69598ZM3.00307 3.26406C3.45203 2.63551 4.35794 2.56054 4.90412 3.10672L7.31935 5.52195C7.6998 5.9024 7.79412 6.48362 7.5535 6.96485L7.21586 7.64013C6.91384 8.24417 6.93619 8.92258 7.30453 9.42159C7.62463 9.85525 8.0632 10.3906 8.62795 10.9553C9.33069 11.6581 9.90926 12.1377 10.3404 12.4495C10.718 12.7226 11.2287 12.7246 11.7248 12.4766L12.6184 12.0298C13.0997 11.7892 13.6809 11.8835 14.0613 12.2639L16.4766 14.6792C17.0227 15.2253 16.9478 16.1312 16.3192 16.5802L14.399 17.9518C13.4153 18.6544 12.0861 18.6849 11.0977 17.9538C9.66433 16.8936 7.67244 15.3031 5.9763 13.607C4.28015 11.9108 2.68972 9.91895 1.62949 8.48561C0.898382 7.49722 0.928865 6.16795 1.63151 5.18424L3.00307 3.26406Z'
          fill='black'
        />
      </g>
    </g>
  </svg>
)

export default CallIcon
